import React, {PureComponent} from 'react';
import {Head} from 'react-static';
import './Home.scss';
import './Test.scss';
import preview from '../../public/images/preview.jpg';
import favicon from '../../public/images/favicon.ico';
import {ContactForm} from '../ContactForm';
import {TextInput} from '../components/TextInput';
import {EmailInput} from '../components/EmailInput';
import {TextArea} from '../components/TextArea/TextArea';
import image1 from '../../public/images/undraw/undraw_hiring_cyhs.svg';
import image3 from '../../public/images/undraw/undraw_wallet_aym5.svg';
import image2 from '../../public/images/undraw/undraw_QA_engineers_dg5p.svg';

export default class Home extends PureComponent {

    render = () => {
        return (
            <div style={{
                display: 'flex',
                flexFlow: 'row wrap',
                alignItems: 'flex-start',
                justifyContent: 'space-around'
            }}>
                <Head>
                    <title>Asbestkrachten | wij zoeken mensen!</title>
                    <meta property="og:type" content="website"/>
                    <link rel="canonical" href=" https://asbestkrachten.nl"/>
                    <meta property="og:url" content="https://www.asbestkrachten.nl/"/>
                    <meta property="og:title" content="Asbestkrachten | wij zoeken mensen!"/>
                    <meta name="description" property="og:description"
                          content="Zoek je een baan? Wij leiden je op en zorgen dat je aan het werk komt!"/>
                    <meta property="og:image" content={preview}/>
                    <link rel="icon" type="image/png" href={favicon}/>
                </Head>
                <section id="flow">
                    <h1>WIJ ZOEKEN JOU!</h1>
                    <p>
                        Wil jij werken in een vak waar je trots op kan zijn? Wij zijn per direct op zoek naar mensen die
                        asbest willen sanereren.
                    </p>
                    <div className="two-lists">
                        <div>
                            <h3>Waar moet je over beschikken?</h3>
                            <ul>
                                <li>Een rijbewijs.</li>
                                <li>De mentaliteit om iedere dag op tijd te komen.</li>
                                <li>Je moet niet bang zijn voor hoogte of kleine ruimtes.</li>
                                <li>Je moet de Nederlandse taal spreken en begrijpen.</li>
                                <li>Je moet graag met je handen werken.</li>
                            </ul>
                        </div>
                        <div>
                            <h3>Wat bieden wij jou?</h3>
                            <ul>
                                <li>Een salaris conform de bouw CAO.</li>
                                <li>Indien nodig alle opleidingen</li>
                                <li>Begeleiding.</li>
                                <li>Alle noodzakelijke spullen om veilig te werken.</li>
                                <li>Werk bij de beste bedrijven van Nederland!</li>
                            </ul>
                        </div>
                    </div>
                    <h1>De eerste 3 dagen</h1>
                    <p>
                        <img src={image1} style={{
                            float: 'left',
                            margin: '1em',
                            maxHeight: 150,
                            maxWidth: '40vw'
                        }}/>
                        Asbest verwijderen is een beroep. Je werkt iedere dag met asbesthoudende toepassingen. Dit doe
                        je natuurlijk niet onbeschermd. Je krijgt dan ook persoonlijke beschermingsmiddelen zoals een
                        masker. Dit masker heb je in bruikleen. Het wordt nooit jouw masker. Maar je moet er natuurlijk
                        wel goed voor zorgen! Om zeker te weten dat je het masker hebt dat bij jouw gezicht past en dus
                        heel goed aansluit op je gezicht moet er een face-fit-test gedaan worden.
                    </p>
                    <p>
                        De training voor DAV-1 duurt 1 of 2 dagen, gevolgd door een examen van 1 dag.
                    </p>
                    <h1>De volgende 7 dagen</h1>
                    <p>
                        <img src={image2} style={{
                            float: 'right',
                            margin: '1em',
                            maxHeight: 150,
                            maxWidth: '40vw'
                        }}/>
                        Nadat je het examen hebt gehaald word je aan een mentor gekoppeld, krijg je het certificaat
                        DAV-1 en worden er persoonlijke beschermingsmiddelen voor je besteld. Veel hoef je dus zelf niet
                        meer te doen,
                        maar je moet nog wel door een medische keuring. De keuring is nodig om er zeker van te zijn dat
                        je fysiek in staat bent om met een masker op te werken.
                    </p>
                    <h1>Daarna: Aan het werk!</h1>
                    <p>
                        <img src={image3} style={{
                            float: 'left',
                            margin: '1em',
                            maxHeight: 150,
                            maxWidth: '40vw'
                        }}/>
                        Als je bent opgeleid dan kun je nog niet ‘echt’ saneren. Saneren moet je leren. Daarom krijg je
                        een mentor toegewezen. Je leert het vak in de praktijk. De DTA (je leidinggevende) legt je uit
                        wat je moet doen. De mentor komt af en toe langs om te kijken hoe het gaat en of er nog
                        bijzonderheden zijn.
                    </p>
                    <ContactForm>
                        <h2>Stuur een bericht</h2>
                        <TextInput required name="contact-name" label="Naam" message="Bij voorkeur voor- en achternaam"
                                   autoComplete="name"/>
                        <EmailInput required name="contact-email" label="e-Mail"
                                    message="Uw e-mailadres wordt alleen gebruikt om met u in contact te komen"/>
                        <TextInput required type="tel" name="contact-phone" label="Telefoonnummer" autoComplete="tel"
                                   message="Uw telefoonnummer wordt alleen gebruikt om met u in contact te komen"/>
                        <TextArea name="contact-message" label="Bericht"/>
                    </ContactForm>
                </section>
            </div>
        );
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/pages/Home.js